import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkflowOptionSetService {
    private http = inject(HttpClient);
    private baseUrl = `${environment.apiConfig[0].uri}`;

    private fieldLoadings = signal(new Map<string, boolean>());
    private fieldOptions = signal(new Map<string, string[]>());

    public isFieldLoading(fieldName: string): boolean {
        return this.fieldLoadings().get(fieldName) ?? false;
    }

    public setFieldLoading(fieldName: string): void {
        const newMap = new Map(this.fieldLoadings());
        newMap.set(fieldName, true);
        this.fieldLoadings.set(newMap);
    }
    public clearFieldLoading(fieldName: string): void {
        const newMap = new Map(this.fieldLoadings());
        newMap.delete(fieldName);
        this.fieldLoadings.set(newMap);
    }

    public setFieldOptions(fieldName: string, options: string[]): void {
        const newMap = new Map(this.fieldOptions());
        newMap.set(fieldName, options);
        this.fieldOptions.set(newMap);
    }

    public getFieldOptions(fieldName: string): string[] | undefined {
        return this.fieldOptions().get(fieldName);
    }

    public clearFieldOptions(fieldName: string): void {
        const newMap = new Map(this.fieldOptions());
        newMap.delete(fieldName);
        this.fieldOptions.set(newMap);
    }

    public clearAllFieldOptions(): void {
        this.fieldOptions.set(new Map());
    }

    public getWorkflowFieldOptionSet(
        validFrom: Date,
        fieldName: string,
        filterFieldName1?: string,
        filterFieldValue1?: string,
        filterFieldName2?: string,
        filterFieldValue2?: string
    ): Observable<string[]> {
        let params = new HttpParams().set('validFrom', new Date(validFrom).toISOString()).set('fieldName', fieldName);

        if (filterFieldName1 && filterFieldValue1) {
            params = params.set('filterFieldName1', filterFieldName1).set('filterFieldValue1', filterFieldValue1);
        }

        if (filterFieldName2 && filterFieldValue2) {
            params = params.set('filterFieldName2', filterFieldName2).set('filterFieldValue2', filterFieldValue2);
        }

        return this.http
            .get<{ options: string[] }>(`${this.baseUrl}/option-sets/00000000-0000-0000-0000-000000000000`, { params })
            .pipe(map(response => response.options));
    }
}
